module.exports = __webpack_public_path__ + "img/2016.58f886c2.svg";